import { Component, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { ApiConstants } from 'src/app/constants/api-constants';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.css']
})
export class CategoryListComponent implements OnInit {

  @Input() list: any[];

  @Output() clicked = new Subject<number>();

  token: string = ApiConstants?.blobSasToken;

  constructor() { }

  ngOnInit(): void { }

  onCardClick(category: any) {
    this.clicked.next(category);
  }

}
